import {menuRouters, otherRouters} from '@/router/router'
import util from '@/libs/util'
import Vue from 'vue'
import Cookies from 'js-cookie'

const children = []
otherRouters.forEach(router => {
  router.children.forEach(child => {
    children.push(child)
  })
})

const app = {
  state: {
    cachePage: [],
    lang: '',
    isFullScreen: false,
    shrink: false, // 左侧栏是否收缩
    menuWidth: '270px', //
    screenWidth: 1280, // 屏幕宽度
    storeInputWidth: 200, // 选择门店组件宽度
    openedSubmenuArr: [], // 要展开的菜单数组
    menuTheme: 'dark', // 主题
    themeColor: '',
    pageOpenedList: [{
      title: '首页',
      path: '/home',
      name: 'HomeIndex'
    }],
    currentPageName: '',
    currentPath: [
      {
        title: '首页',
        path: '/home',
        name: 'HomeIndex'
      }
    ], // 面包屑数组
    menuList: [],
    routers: [
      ...otherRouters,
      ...menuRouters
    ],
    tagsList: [],
    messagesScrolling: [], // 滚动消息列表
    dontCache: ['text-editor', 'artical-publish'] // 在这里定义你不想要缓存的页面的name属性值(参见路由配置router.js)
  },
  mutations: {
    setTagsList (state, list) {
      state.tagsList.push(...list)
    },
    updateMenulist (state, user) {
      if (state.menuList.length > 0) {
        return
      }
      const menuList = []
      const authorities = user.authorities || []
      menuRouters.forEach((item, index) => {
        if (item.has) {
          if (util.has(authorities, item)) {
            if (item.children.length === 1 && util.has(authorities, item.children[0])) {
              menuList.push(item)
            } else {
              let len = menuList.push(item)
              let childrenArr = []
              childrenArr = item.children.filter(child => {
                return util.has(authorities, child)
              })
              menuList[len - 1].children = childrenArr
            }
          }
        } else {
          if (item.children.length === 1 && util.has(authorities, item.children[0])) {
            menuList.push(item)
          } else {
            let len = menuList.push(item)
            let childrenArr = []
            childrenArr = item.children.filter(child => {
              return util.has(authorities, child)
            })
            if (childrenArr === undefined || childrenArr.length === 0) {
              menuList.splice(len - 1, 1)
            } else {
              let handledItem = JSON.parse(JSON.stringify(menuList[len - 1]))
              handledItem.children = childrenArr
              menuList.splice(len - 1, 1, handledItem)
            }
          }
        }
      })
      state.menuList = menuList
    },
    changeMenuTheme (state, theme) {
      state.menuTheme = theme
    },
    changeMainTheme (state, mainTheme) {
      state.themeColor = mainTheme
    },
    changeShrink (state, shrink) {
      state.shrink = shrink
    },
    changeMenuWidth (state, menuWidth) {
      state.menuWidth = menuWidth
    },
    changeScreenWidth (state, screenWidth) {
      state.screenWidth = screenWidth
      if (screenWidth > 1600) {
        state.storeInputWidth = 200
      } else if (screenWidth > 1440) {
        state.storeInputWidth = 180
      } else {
        state.storeInputWidth = 160
      }
    },
    addOpenSubmenu (state, name) {
      let hasThisName = false
      let isEmpty = false
      if (name.length === 0) {
        isEmpty = true
      }
      if (state.openedSubmenuArr.indexOf(name) > -1) {
        hasThisName = true
      }
      if (!hasThisName && !isEmpty) {
        state.openedSubmenuArr.push(name)
      }
    },
    closePage (state, name) {
      state.cachePage.forEach((item, index) => {
        if (item === name) {
          state.cachePage.splice(index, 1)
        }
      })
    },
    initCachepage (state) {
      if (localStorage.cachePage) {
        state.cachePage = JSON.parse(localStorage.cachePage)
      }
    },
    removeTag (state, name) {
      state.pageOpenedList.map((item, index) => {
        if (item.name === name) {
          state.pageOpenedList.splice(index, 1)
        }
      })
    },
    pageOpenedList (state, get) {
      let openedPage = state.pageOpenedList[get.index]
      if (get.argu) {
        openedPage.argu = get.argu
      }
      if (get.query) {
        openedPage.query = get.query
      }
      state.pageOpenedList.splice(get.index, 1, openedPage)
      localStorage.pageOpenedList = JSON.stringify(state.pageOpenedList)
    },
    setOpenedList (state) {
      state.pageOpenedList = localStorage.pageOpenedList ? JSON.parse(localStorage.pageOpenedList) : [children[0]]
    },
    setCurrentPath (state, pathArr) {
      state.currentPath = pathArr
    },
    setCurrentPageName (state, name) {
      state.currentPageName = name
    },
    setAvator (state, path) {
      localStorage.avatorImgPath = path
    },
    switchLang (state, lang) {
      state.lang = lang
      Vue.config.lang = lang
    },
    increateTag (state, tagObj) {
      if (!util.oneOf(tagObj.name, state.dontCache)) {
        state.cachePage.push(tagObj.name)
        localStorage.cachePage = JSON.stringify(state.cachePage)
      }
      state.pageOpenedList.push(tagObj)
      localStorage.pageOpenedList = JSON.stringify(state.pageOpenedList)
    },
    clearAllTags (state) {
      state.pageOpenedList.splice(1)
      state.cachePage.length = 0
      localStorage.pageOpenedList = JSON.stringify(state.pageOpenedList)
    },
    clearMenuList (state) {
      state.menuList = []
    },
    clearOpenedSubmenu (state) {
      state.openedSubmenuArr.length = 0
    },
    clearOtherTags (state, vm) {
      let currentName = vm.$route.name
      let currentIndex = 0
      state.pageOpenedList.forEach((item, index) => {
        if (item.name === currentName) {
          currentIndex = index
        }
      })
      if (currentIndex === 0) {
        state.pageOpenedList.splice(1)
      } else {
        state.pageOpenedList.splice(currentIndex + 1)
        state.pageOpenedList.splice(1, currentIndex - 1)
      }
      state.cachePage = state.cachePage.filter(item => {
        return item === currentName
      })
      localStorage.pageOpenedList = JSON.stringify(state.pageOpenedList)
    },
    SET_MESSAGESSCROLLING (state, messages) {
      state.messagesScrolling = messages
    }
  },
  actions: {
    logout ({state, commit}) {
      // 关闭标签
      commit('clearAllTags')
      // 清除打开的菜单
      commit('clearOpenedSubmenu')
      // 删除menuList
      commit('clearMenuList')

      // 清理缓存
      Cookies.remove('account')
      // Cookies.remove('password')
      localStorage.clear()
    },
    setMessagesScrolling ({ state, commit }, messages) {
      commit('SET_MESSAGESSCROLLING', messages)
    }
  }
}

export default app



// WEBPACK FOOTER //
// ./src/store/modules/app.js